"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Player = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdVideoPlayer = _interopRequireDefault(require("cccisd-video-player"));
var _defaultTemplate = _interopRequireDefault(require("./defaultTemplate.js"));
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _cccisdSprite = _interopRequireDefault(require("cccisd-sprite"));
var _cccisdSound = require("cccisd-sound");
var _sprites = _interopRequireDefault(require("../sprites.js"));
var _cccisdFlowIframeResizer = _interopRequireDefault(require("cccisd-flow-iframe-resizer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var aspectRatioHeight = {
  '16/9': 16 / 9,
  '4/3': 4 / 3,
  '1/1': 1 / 1
};
var Player = exports.Player = /*#__PURE__*/function (_Component) {
  _inherits(Player, _Component);
  function Player() {
    var _this;
    _classCallCheck(this, Player);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Player, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      ended: false,
      isPlaying: false,
      hasPlayedOnce: false,
      transformW: 1,
      transformH: 1,
      lastClientWidth: -1
    });
    _defineProperty(_assertThisInitialized(_this), "_updateTransform", function () {
      var settings = _this.props.settings;
      if (!_this.spriteWrapper) {
        return;
      }
      if (settings.width !== 0) {
        _this.setState({
          transformW: _this.spriteWrapper.clientWidth / settings.width,
          // spriteWrapper needs to be spriteStage
          transformH: _this.spriteWrapper.clientHeight / settings.height
        });
        _this.setState({
          lastClientWidth: _this.spriteWrapper.clientWidth
        });
        _this.setState({
          lastClientHeight: _this.spriteWrapper.clientHeight
        });
      } else {
        _this.setState({
          transformW: 1,
          transformH: 1
        });
      }
    });
    // start audio and sprite animation at the same time
    _defineProperty(_assertThisInitialized(_this), "playSpriteAndAudio", function () {
      if (!_this.props.isPreview) {
        if (_this.sprite) {
          _this.setState({
            isPlaying: true
          });
          _this.sprite.play(_this.props.settings.startAnimationLabel);
          if (_this.props.field.onChange) {
            _this.props.field.onChange(_objectSpread(_objectSpread({}, _this.props.field.value), {}, {
              played: true
            }));
          }
        }
        if (_this.props.settings.audio) {
          _this.play(_this.props.settings.audio.meta.audio.url);
        }
      } else if (_this.sprite) {
        _this.setState({
          isPlaying: false
        });
        _this.sprite.play(_this.props.settings.idleAnimationLabel);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "play", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _cccisdSound.play)({
                url: url,
                onEnd: function onEnd() {
                  if (_this.sprite) {
                    _this.sprite.play(_this.props.settings.idleAnimationLabel);
                    if (_this.props.settings.loop) {
                      _this.playSpriteAndAudio();
                    }
                  }
                }
              });
            case 2:
              _this.sound = _context.sent;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "_getSmallerNotZero", function (val1, val2) {
      if (val1 < val2 && val1 !== 0) {
        return val1;
      }
      if (val2 !== 0) {
        return val2;
      }
      return 1;
    });
    _defineProperty(_assertThisInitialized(_this), "_getOrigin", function () {
      switch (_this.props.settings.origin) {
        case 'TL':
          return _style["default"].TL;
        case 'TC':
          return _style["default"].TC;
        case 'TR':
          return _style["default"].TR;
        case 'CL':
          return _style["default"].CL;
        case 'CC':
          return _style["default"].CC;
        case 'CR':
          return _style["default"].CR;
        case 'BL':
          return _style["default"].BL;
        case 'BC':
          return _style["default"].BC;
        case 'BR':
          return _style["default"].BR;
        default:
          return _style["default"].CC;
      }
    });
    // get the total sprite video seconds based on the json object (js file)
    _defineProperty(_assertThisInitialized(_this), "_getVideoSeconds", function () {
      var settings = _this.props.settings;
      if (_this.state.isPlaying && !_this.state.hasPlayedOnce && settings.spriteHandle && settings.spriteHandle !== 'default') {
        var zoeObj = _sprites["default"].find(function (item) {
          return item.handle === settings.spriteHandle;
        }).json;
        return zoeObj.animations[settings.startAnimationLabel].frames.length / (zoeObj.framerate * zoeObj.animations[settings.startAnimationLabel].speed);
      }
    });
    return _this;
  }
  _createClass(Player, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._updateTransform();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.sound) {
        this.sound.stop();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.spriteWrapper) {
        return;
      }
      if (this.spriteWrapper.clientWidth !== this.state.lastClientWidth || this.spriteWrapper.clientHeight !== this.state.lastClientHeight) {
        this._updateTransform();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        settings = _this$props.settings,
        accommodations = _this$props.accommodations;
      var url = '';
      if (settings.id) {
        switch (settings.type) {
          case 'vimeo':
            url += 'https://player.vimeo.com/video/' + settings.id;
            break;
          case 'youtube':
            url += 'https://www.youtube.com/watch?v=' + settings.id;
            break;
          case 'producer':
            // fake url just to recognize that it's producer
            url += 'https://producer.com/' + settings.id;
            break;
          case 'file':
          case 'sprite':
          default:
            url = settings.id;
            break;
        }
      }
      var playing = this.props.isPreview ? false : settings.playOnStart;
      var constrainVal = this._getSmallerNotZero(this.state.transformW, this.state.transformH);
      var originStyle = this._getOrigin();
      var spriteStyle = settings.type === 'sprite' && settings.spriteHandle === 'default' ? _style["default"].noSpriteSelected : '';
      var zoeHandle = _sprites["default"].find(function (item) {
        return item.handle === settings.spriteHandle;
      });
      var marginX = settings.marginOverride && settings.marginValX ? settings.marginValX : 0;
      var marginY = settings.marginOverride && settings.marginValY ? settings.marginValY : 0;
      var aspectRatio = aspectRatioHeight[settings.aspectRatio] || aspectRatioHeight['16/9'];
      var videoObject = settings.type !== 'sprite' ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"]["".concat(settings.type, "Type")] + ' ' + _style["default"]["".concat(settings.size, "Size")]
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFlowIframeResizer["default"], {
        aspectRatio: aspectRatio
      }, /*#__PURE__*/_react["default"].createElement(_cccisdVideoPlayer["default"], _extends({
        url: url,
        playing: playing,
        mobileControls: true
      }, settings, {
        width: "100%",
        height: "auto",
        onEnded: function onEnded() {
          _this2.setState({
            ended: true
          });
          _this2.props.field.onChange(_objectSpread(_objectSpread({}, _this2.props.field.value), {}, {
            ended: true
          }));
          if (settings.autoAdvance && _this2.props.goToNextPage) {
            _this2.props.goToNextPage();
          }
        },
        onProgress: function onProgress(metrics) {
          var data = {
            played: metrics.played,
            playedSeconds: metrics.playedSeconds,
            ended: _this2.state.ended
          };
          if (_this2.props.field.onChange) {
            _this2.props.field.onChange(data);
          }
        },
        showPlaceholder: this.props.isPreview
      })))) : /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(element) {
          _this2.spriteWrapper = element;
        },
        className: _style["default"].spriteWrapper + ' ' + spriteStyle + ' ' + originStyle,
        style: {
          transform: "scale(".concat(constrainVal),
          marginLeft: marginX,
          marginTop: marginY
        }
      }, settings.spriteHandle && settings.spriteHandle !== 'default' && zoeHandle !== undefined && /*#__PURE__*/_react["default"].createElement(_cccisdSprite["default"], {
        ref: function ref(element) {
          _this2.sprite = element;
        },
        width: settings.width,
        height: settings.height,
        zoe: zoeHandle.json,
        onAnimationDone: function onAnimationDone() {
          if (_this2.state.isPlaying) {
            if (_this2.props.field.onChange) {
              _this2.props.field.onChange(_objectSpread(_objectSpread({}, _this2.props.field.value), {}, {
                ended: true,
                playedSeconds: _this2._getVideoSeconds()
              }));
            }
            _this2.setState({
              ended: true,
              isPlaying: false,
              hasPlayedOnce: true
            });
            if (settings.autoAdvance && _this2.props.goToNextPage) {
              _this2.props.goToNextPage();
            }
          }
        },
        onLoad: function onLoad() {
          if (_this2.props.settings.playOnStart) {
            _this2.playSpriteAndAudio();
          } else {
            _this2.sprite.play(_this2.props.settings.idleAnimationLabel);
          }
        },
        onClick: function onClick() {
          if (!_this2.state.isPlaying) {
            _this2.playSpriteAndAudio();
          }
        }
      }));
      var templateProps = _objectSpread({
        video: videoObject,
        // Advanced props
        settings: settings,
        playerTemplateProps: this.props.playerTemplateProps,
        accommodations: accommodations
      }, this.props.templateExtraProps);
      var Template = this.props.template || _defaultTemplate["default"];
      return /*#__PURE__*/_react["default"].createElement(Template, templateProps);
    }
  }]);
  return Player;
}(_react.Component);
_defineProperty(Player, "propTypes", {
  settings: _propTypes["default"].object,
  field: _propTypes["default"].object,
  isPreview: _propTypes["default"].bool,
  template: _propTypes["default"].func,
  templateExtraProps: _propTypes["default"].object,
  playerTemplateProps: _propTypes["default"].object,
  registerAction: _propTypes["default"].func,
  setParameters: _propTypes["default"].func,
  accommodations: _propTypes["default"].object,
  goToNextPage: _propTypes["default"].func
});
_defineProperty(Player, "defaultProps", {
  registerAction: function registerAction() {},
  setParameters: function setParameters() {}
});
var validate = function validate(value, settings) {
  if (settings.mustWatch && (!value || !value.ended)) {
    return settings.mustWatchMessage;
  }
  return '';
};
var _default = exports["default"] = (0, _cccisdSurveyCommon.playerWrapper)({
  validate: validate
})(Player);